import React from 'react';
import { observer } from 'mobx-react';
import { Modal } from 'antd';
import { useStore } from '../../../../store/rootStore';
import QuickRepliesMenu from './index';
// Standalone quick reply manager opened from general settings
const QuickRepliesSettingsModal = observer(() => {
    const { quickRepliesStore } = useStore();
    return (React.createElement(Modal, { open: quickRepliesStore.isSettingsModalOpen, onCancel: quickRepliesStore.closeSettingsModal, bodyStyle: {
            padding: '0',
            boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.2)',
            borderRadius: '2px',
            maxHeight: '90vh',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
        }, footer: null, closable: false, width: 800, centered: true, destroyOnClose: true },
        React.createElement(QuickRepliesMenu, { closeMenu: quickRepliesStore.closeSettingsModal, noQuickReplies: quickRepliesStore.quickReplies.length === 0, enableChannelTargets: true, showChannelFilter: true })));
});
export default QuickRepliesSettingsModal;
